import React from 'react';
import { Pill } from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';
import { useImpression } from '@thd-olt-component-react/impression';
import './anchor-links.scss';

const { string, shape, number } = proptypes;

const AnchorPill = ({ componentId, componentPosition, link }) => {

  const category = link.label.replace(/ /g, '');
  const isExternal = !link?.href?.includes('www.homedepot.com');
  const { ref, clickID } = useImpression({
    data: {
      id: componentId,
      name: 'AnchorLinks',
      component: 'AnchorLinks',
      type: 'content',
      position: componentPosition,
      category
    }
  });
  return (
    <div
      ref={ref}
      /* eslint-disable-next-line react/no-unknown-property */
      clickid={clickID}
      key={`card-position-${componentPosition}`}
      data-component="AnchorLink"
    >
      <Pill
        key={componentId}
        label={link.label}
        component="a"
        href={link.href}
        clickable
        {...(isExternal && { target: '_blank', rel: 'noopener noreferrer' })}
      />
    </div>
  );
};

AnchorPill.propTypes = {
  componentId: string.isRequired,
  componentPosition: number.isRequired,
  link: shape.isRequired
};

AnchorPill.displayName = 'AnchorPill';

export { AnchorPill };
